<template>
    <div v-if="products.length > 0">
        <div class="row">
            <div class="col">
                <h3>{{ translations['Others bought'] }}</h3>
            </div>
        </div>
        <div class="row last-products">
            <div class="col product-box">
                <div v-for="product in products" :key="product.id">
                    <product-line-small :product="product" />
                </div>
            </div>
            <div class="d-mobile-only slider-white--controls text-center">
                <img src="/themes/realgeek/img/chevron-left.svg" class="last-products--controls--left-button" width="12" height="23">
                <img src="/themes/realgeek/img/chevron-right.svg" class="last-products--controls--right-button" width="12" height="23">
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import ProductLineSmall from "./ProductLineSmall";

    export default {
        name: 'accessories',
        components: {ProductLineSmall},
        computed: {
            ...mapState({
                translations: state => state.translations,
                products: state => state.accessories.slice(0, 3),
            }),
        },
    }
</script>
<style scoped lang="scss">
    h3 {
        font-size: 24px;
        font-weight: 700;
        text-transform: uppercase;
    }
    @media (max-width: 1349px) {
        h3 {
            text-align: center;
            font-size: 18px;
        }
    }

    @media (max-width: 1349px) {
        h3{
            text-align: center;
            font-size: 18px;
        }
        .last-products {
            overflow: hidden;
            max-width: 100%;
            margin-left: 0;
            display: block;

            .product-box {
                max-width: unset;
            }

            .last-products--controls--left-button {
                position: absolute;
                top: 105px;
                left: 10px;
                width: 10px;
            }

            .last-products--controls--right-button {
                position: absolute;
                top: 105px;
                right: 10px;
                width: 10px;
            }
        }
    }
</style>
